import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'
import { trackPromotionClick } from 'helpers'

export class Hero extends React.PureComponent<Hero.Props, Hero.State> {
  public static sectionId = 'hero';

  public componentDidMount =() => {
    // document.querySelector('.body-wrapper').classList.remove('pt-5-6', 'pt-9-6', 'md:pt-11-3')
  }

  constructor(props) {
    super(props)

    const isDesktop = window.innerWidth > 960
    this.state = {
      isDesktop: isDesktop,
      hovered: false,
      playing: isDesktop ? this.props.section?.settings?.autoplay ? true : false : false,
      alternateText: false,
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        const isDesktop = window.innerWidth > 960
        this.setState({ isDesktop: isDesktop })
      })
    }
  }


  public UNSAFE_componentWillReceiveProps (nextProps) {
    if (!this.props.section.settings && nextProps.section.settings?.autoplay) {
      this.setState({
        playing: true,
      })
    }
  }

  public getRatioPadding (ratioStr) {
    const ratioSplit = ratioStr?.split(':')
    const ratio1 = parseInt(ratioSplit?.[0])
    const ratio2 = parseInt(ratioSplit?.[1])

    if (ratio1 && ratio2) {
      return `${(ratio2 / ratio1) * 100}%`
    }

    return null
  }

  public render(): JSX.Element {
    const { section } = this.props
    const { article } = this.props.data.section

    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = article?.settings?.allow_full_width_images

    const { settings } = section
    const contentClasses: string[] = []
    const fullwidth = Helpers.check(settings, 'settings.fullwidth') ? settings.fullwidth : false
    const { image } = settings
    const mobileImage = settings.imagemobile ? settings.imagemobile : settings.image
    const ctaClasses = []


    if (this.state.isDesktop) {
      settings && settings.horizontal
        ? contentClasses.push(
          `justify-${settings.horizontal.toLowerCase()}`
        )
        : null
      settings && settings.alignment
        ? contentClasses.push(`text-${settings.alignment.toLowerCase()}`) : null
      settings && settings.vertical
        ? contentClasses.push(
          `items-${settings.vertical.toLowerCase()}`
        )
        : null

      settings && settings.contentcolor ? contentClasses.push(settings.contentcolor === 'black' ? 'text-black': 'text-white') : null
      settings && settings.contentcolor ? ctaClasses.push(settings.contentcolor === 'black' ? 'text-black border-black' : 'text-white border-white') : null
    }

    let ctaAlignment = settings?.cta_alignment

    if (!this.state.isDesktop) {
      settings && settings.horizontalmobile
        ? contentClasses.push(
          `justify-${settings.horizontalmobile.toLowerCase()}`
        )
        : null
      settings && settings.alignmentmobile
        ? contentClasses.push(`text-${settings.alignmentmobile.toLowerCase()}`) : null
      settings && settings.verticalmobile
        ? contentClasses.push(
          `items-${settings.verticalmobile.toLowerCase()}`
        )
        : null

      ctaAlignment = settings?.cta_alignment_mobile

      settings && settings.contentcolormobile ? contentClasses.push(settings.contentcolormobile === 'black' ? 'text-black': 'text-white') : null
      settings && settings.contentcolormobile ? ctaClasses.push(settings.contentcolormobile === 'black' ? 'text-black border-black' : 'text-white border-white') : null
    }

    const {
      productctaname,
      productctalinkurl,
      productctalinktext
    } = settings

    const ctaReady = productctaname && productctalinkurl && productctalinktext

    const displayType = settings.halfwidth ? 'inline-block' : 'block'

    const desktopRatio = settings.halfwidth ? '8:9' : '16:9'
    const mobileRatio = '16:9'
    const desktopImageRatioPadding = this.getRatioPadding(settings.imageratiodesktop)
    const mobileImageRatioPadding = this.getRatioPadding(settings.imageratiomobile)

    const classes = `
      ${settings.hideondesktop ? `${displayType} md:hidden` : ''} 
      ${settings.hideonmobile ? `hidden md:${displayType}` : ''} 
      ${!settings.hideonmobile && !settings.hideondesktop ? `block md:${displayType}` : ''} 
      ${this.state.isDesktop && settings.halfwidth ? 'w-6/12' : 'w-full'}
    `

    return (
      <Snippets.Link href={settings.linkurl}>
        <section className={`dynamic-hero ${classes} ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''}`}>
          <div
            className={`
              dynamic-hero-h overflow-hidden w-full relative
              ${fullwidth ? '' : settings?.videocontainer ? 'max-w-videocontainer mb-3-2 mt-6-4 lg:mb-6-4 lg:mt-12-8' : 'max-w-container'}
              mx-auto
            `}
            onMouseEnter={() => this.setState({ hovered: true })}
            onMouseLeave={() => this.setState({ hovered: false })}
          >
            {this.state.isDesktop && !settings.videourl ? (
              <div style={{ height: desktopImageRatioPadding ? 0 : settings?.fullHeight ? '100%' : '900px', position: 'relative', overflow: 'hidden', paddingBottom: desktopImageRatioPadding }}>
                <Snippets.Image
                  alt={settings.title || 'Hero banner image'}
                  ratio={desktopImageRatioPadding ? null : 'natural'}
                  src={image}
                  preventLazy
                />
              </div>
            ) : (
              <Snippets.VideoPlayer
                alt={settings.title || 'Hero banner video'}
                ratio={(this.state.isDesktop ? desktopRatio : mobileRatio)}
                className={'absolute h-full inset-0 hidden lg:block'}
                preventLazy
                src={settings.videourl}
                playing={this.state.playing}
                autoplay={settings.autoplay}
                onPlay={() => this.setState({ playing: true })}
                onPause={() => this.setState({ playing: false })}
                //coverImage={image}
                playsInline={true}
              />
            )}
            {!this.state.isDesktop && !settings.mobilevideourl ? (
              <div style={{ height: mobileImageRatioPadding ? 0 : 'auto', position: 'relative', overflow: 'hidden', paddingBottom: mobileImageRatioPadding }}>
                <Snippets.Image
                  alt={settings.title || 'Hero banner mobile image'}
                  ratio={mobileImageRatioPadding ? null : 'natural'}
                  src={mobileImage}
                  preventLazy
                />
              </div>
            ) : (
              <Snippets.VideoPlayer
                alt={settings.title || 'Hero banner video'}
                ratio={'9:16'}
                className={'absolute h-full inset-0 block lg:hidden max-h-144'}
                preventLazy
                src={settings.mobilevideourl}
                playing={this.state.playing}
                autoplay={settings.autoplay}
                onPlay={() => this.setState({ playing: true })}
                onPause={() => this.setState({ playing: false })}
                //coverImage={mobileImage}
                playsInline={true}
              />
            )}
            {this.state.playing || (<img className="pointer-events-none w-full h-full top-0 left-0 absolute object-cover" src={this.state.isDesktop ? image :  mobileImage} alt="" />)}
            <div
              className={`absolute z-20 w-full bottom-0 left-0 transition-transform duration-300 transform ${(this.state.hovered && this.state.isDesktop) ? 'translate-y-0' : 'translate-y-full'}`}
            >
              {ctaReady && (
                <div
                  style={{
                    backdropFilter: 'blur(10px)',
                    backgroundColor: 'rgba(255,255,255,0.45)',
                  }}
                  className={'py-1 px-1-3'}
                >
                  <span className={'font-bold text-sm'}>{ productctaname }</span>
                  <span className={'ml-1 text-sm'}>
                    <Snippets.Link
                      className={'underline'}
                      title={productctalinktext}
                      href={productctalinkurl}
                    >{ productctalinktext }</Snippets.Link>
                  </span>
                </div>
              )}
            </div>
            <div className={`absolute inset-0 flex z-10 mx-auto w-full max-w-container px-1-6 md:px-3-2 pt-12 pb-10 ${contentClasses.join(' ')}`}>
              {settings.title || settings.content || (settings.linkurl && settings.linktext) ? (<div className={`w-full md:w-4/5 ${settings.contentcontainersize == 'medium' ? null : 'max-w-md'}`}>
                {settings.title ? (
                  <Snippets.Heading
                    className={'mb-2'}
                    size={settings.headingstyle == 'h5' ? 'h5Alt' : 'h1'}
                    tag={settings.headingstyle == 'h5' ? settings.headingstyle : 'h2'}
                  >
                    {settings.title}
                  </Snippets.Heading>
                ) : null}
                {settings.content ? (
                  <Snippets.RichText className={`${settings.contentseriffont ? 'font-mono' : null} m-0-3`} size={1}>
                    {(this.state.isDesktop || !settings.contentmobile) ? settings.content : settings.contentmobile}
                  </Snippets.RichText>
                ) : null}
                {settings.linktext ? (
                  <Snippets.Button
                    onClick={() => trackPromotionClick(
                      [{
                        id: section.id,
                        name: settings.title,
                        creative: 'hero',
                      }],
                      settings.linkurl
                    )}
                    colour={settings.color === 'black' ? 'primary' : settings.color === 'white' ? 'secondary' : settings.color === 'transparent' ? 'secondary-transparent' : 'secondary-transparent-reverse'}
                    buttonStyle={settings.button_style}
                    className={`mt-2 md:mt-3 pt-1-1 pb-1 block ${ctaAlignment} ${ctaClasses.join(' ')}`}
                    title={settings.linktext}
                  >
                    <Snippets.Heading size={'h5'} tag={'p'}>{settings.linktext}</Snippets.Heading>
                  </Snippets.Button>
                ) : null}
              </div> ) : <div />}
            </div>
          </div>
          {settings.alternativetext && (
            <div className={`${(this.state.alternateText && settings?.alternativetext) ? 'h-full' : 'h-0'} overflow-hidden max-w-2xl mx-auto`}>
              <Snippets.RichText className="py-2">
                {settings?.alternativetext?.replace(/(?:\r\n|\r|\n)/g, '<br />')}
              </Snippets.RichText>
            </div>
          )}
          {ctaReady && (
            <div className={'overflow-hidden max-w-2xl mx-auto py-1 px-1 block md:hidden'}>
              <span className={'font-bold tracking-wide text-sm'}>{ productctaname }</span>
              <span className={'ml-1 text-sm'}>
                <Snippets.Link
                  className={'underline'}
                  title={productctalinktext}
                  href={productctalinkurl}
                >{ productctalinktext }</Snippets.Link>
              </span>
            </div>
          )}
        </section>
      </Snippets.Link>
    )
  }

  private toggleAlternateText = (): void => {
    this.setState((prevState) => ({
      alternateText: !prevState.alternateText
    }))
  }
}

export namespace Hero {
  export interface Options extends ShopifyNext.Section<{
    title?: string;
    headingstyle?: string;
    content?: string;
    contentmobile?: string;
    contentcolor?: string
    contentcolormobile?: string
    linktext?: string;
    linkurl?: string;
    image?: string;
    imagemobile?: string;
    imageratiodesktop?: string;
    imageratiomobile?: string;
    videourl?: string;
    mobilevideourl?: string;
    autoplay: boolean;
    controls: boolean;
    color?: string;
    button_style?: string;
    vertical?: string;
    horizontal?: string;
    alignment?: string;
    verticalmobile: string;
    horizontalmobile: string;
    alignmentmobile: string;
    fullwidth?: boolean;
    fullHeight?: boolean;
    alternativetext: string;
    videocontainer?: boolean;
    contentcontainersize?: string;
    contentseriffont?: boolean;
    hideondesktop: boolean;
    hideonmobile: boolean;
    productctaname: string;
    productctalinkurl: string;
    productctalinktext: string;
    halfwidth: boolean;
    cta_alignment_mobile: string;
    cta_alignment: string;
  }> {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: Hero.Options;
  }
  export interface State {
    playing: boolean;
    hovered: boolean;
    alternateText: boolean;
    isDesktop: boolean;
  }
}
